module.exports = __webpack_public_path__ + "static/media/vector.74caa575.png";